import { memo, useEffect, useRef } from 'react'

interface Props {
  hasNextPage: boolean
  action: () => void
}

export const Observer = memo(({ hasNextPage, action }: Props) => {
  const divRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!divRef.current) {
      return
    }

    const observer = new IntersectionObserver((entries, obs) => {
      const { isIntersecting } = entries[0]

      if (!hasNextPage) {
        obs.disconnect()

        return
      }

      if (isIntersecting) {
        action()
      }
    })

    observer.observe(divRef.current)

    return () => {
      observer.disconnect()
    }
  }, [action, hasNextPage])

  return <div ref={divRef} className="w-1 h-1 opacity-0" />
})
